import styled from 'styled-components';
import { CustomThemeToken } from '@/theme/theme.utils';
import { breakpoints } from '@/utils/util-breakpoints';

export const StyledTaskRow = styled.div<{ theme: { token: CustomThemeToken } }>`
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: ${({ theme: { token } }) => token.margin}px;
    border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    @media (max-width: ${breakpoints.lg}px) {
        flex-direction: column;
        align-items: flex-start;
        gap: ${({ theme: { token } }) => token.margin}px;
    }
    .task-row-label-section {
        display: flex;
        align-items: start;
        gap: ${({ theme: { token } }) => token.marginSM}px;
        .task-row-icon {
            background-color: ${({ theme: { token } }) => token.colorPrimaryBg};
            color: ${({ theme: { token } }) => token.colorPrimary};
        }
        .task-row-label-section-content {
            align-self: end;
        }
        .task-row-label {
            display: flex;
            align-items: center;
            gap: ${({ theme: { token } }) => token.marginSM}px;
            font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
            font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
            .anticon {
                cursor: pointer;
                color: ${({ theme: { token } }) => token.colorTextSecondary};
            }
        }
        .task-row-subtitle {
            font-size: ${({ theme: { token } }) => token.fontSize}px;
            color: ${({ theme: { token } }) => token.colorTextSecondary};
        }
    }
    .task-row-values-wrapper {
        display: flex;
        flex-direction: column;
        align-items: end;
        align-self: end;
        flex-grow: 1;
        gap: ${({ theme: { token } }) => token.marginXL}px;
        @media (max-width: ${breakpoints.lg}px) {
            width: 100%;
        }
    }
    .stage-task-input-field {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 0;
        .ant-form-item-row {
            width: 100%;
            justify-content: end;
            .ant-form-item-label {
                align-self: center;
                & > label {
                    color: ${({ theme: { token } }) => token.colorTextSecondary};
                    font-size: ${({ theme: { token } }) => token.fontSize}px;
                }
            }
            .ant-form-item-control {
                max-width: 360px;
            }
            .ant-form-item-control-input-content {
                justify-content: flex-end;
            }
            
            .stage-task-input {
                display: flex;
                width: 100%;
                color: ${({ theme: { token } }) => token.colorTextSecondary};
                font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
                .ant-input-number-input-wrap {
                    width: 100%;
                }
                .ant-input-number-input {
                    height: 100%;
                }
                .ant-radio-button-wrapper {
                    flex-grow: 1;
                    text-align: center;
                    padding: 0;
                }
                .ant-picker-input > input {
                    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
                }
                @media (max-width: ${breakpoints.md}px) {
                    font-size: ${({ theme: { token } }) => token.fontSize}px;
                    .ant-radio-button-wrapper,
                    .ant-picker-input > input {
                        font-size: ${({ theme: { token } }) => token.fontSize}px;
                    }   
                }
                &.ant-switch {
                    width: auto;
                }
            }
        }
    }
`;


